<template lang="pug">
  div.hello
    nav.navbar.navbar-light.navbar-expand-lg.fixed-top.bg-white(style="border-bottom:solid 2px gray;padding:0px;")
        div.container-fluid
          a.navbar-brand.navbar-brand-label(href="/", style="margin-left:8px;")
            img.d-inline-block.align-bottom.navbar-brand-img(src="../assets/img/logo.svg")
            | Gokaku Essay Library
          button.navbar-toggler(data-toggle="collapse", data-target="#navcol-1", style="margin-right:8px;")
            span.sr-only Toggle navigation
            span.navbar-toggler-icon
          div.collapse.navbar-collapse.align-self-end#navcol-1(style="background-color: white; margin-bottom: 2px;")
            ul.nav.navbar-nav.d-flex.align-items-end(style="font-size:1.5rem;")
              li.nav-item(role="presentation")
                router-link.nav-link(to="/database", style="padding:5px 8px;")
                  font-awesome-icon(icon="database")
                  | &nbsp;Database
              li.nav-item(role="presentation")
                router-link.nav-link(to="/mypage", style="padding:5px 8px;")
                  font-awesome-icon(icon="user")
                  | &nbsp;My Page
              //- li.nav-item(role="presentation")
              //-   a.nav-link(href="#", style="padding:5px 8px;")
              //-     font-awesome-icon(icon="question-circle")
              //-     | &nbsp;Usage
            div.login-name(v-show="this.$store.state.auth.loggedin")
              div
                div
                  div
                    span.navbar-text.login-name#loggedinname(v-popover="{ name:'prof' }") {{ this.$store.state.auth.email }}
                    popover(name="prof" :width="100")
                      span(style="margin: 3px; color: #42b983; cursor:pointer;", @click="toMyPage") MyPage
                      br
                      span(style="margin: 3px; color: #42b983; cursor:pointer;", @click="logout") Logout
                    div.d-lg-none
                      span.navbar-text(style="margin: 3px; color: #42b983; cursor:pointer;", @click="toMyPage") MyPage
                      br
                      span.navbar-text(style="margin: 3px; color: #42b983; cursor:pointer;", @click="logout") Logout
            
            div.login-name(v-show="!this.$store.state.auth.loggedin")
              router-link.navbar-text.login-name#loginlabel(v-show="this.$route.path!='/login'",tag="a", :to="{ path:'/login', query:{ next:$route.fullPath }}", style="margin: 3px;") ログイン/登録
            div.shop-cart(v-show="!this.$store.state.auth.loggedin || this.$store.state.auth.role==='user'")
              div#cartbutton(v-popover="{ name:innerWidth()<992? '':'cart-quick' }", @click='showCart')
                font-awesome-icon(icon="shopping-cart", style="margin-right: 7px;")
                span {{ $store.state.listitems.cart.length }}
              popover(name="cart-quick" :width="600")
                div.container-fluid(style="padding-bottom: 10px;")
                  div.row
                    div.col
                      span(style="font-size:16px; font-weight:bold;") カート
                  div.row(v-show="fail")
                    div.col
                      p(style="cursor:pointer; font-size: 14px;", @click="showCart")
                        | 読み込みに失敗しました
                        br
                        | クリックして再読み込み
                  div.row(v-show="!fail")
                    div.col
                        span(v-show="$store.state.listitems.cart.length==0" style="font-size: 16px;") カートは空です
                        div.loader(v-show="result.status==0", style="margin-top: 15px; margin-bottom: 20px;")
                          div.loader-inner.ball-clip-rotate
                            div
                        div.table-responsive(v-show="result.status==200 && $store.state.listitems.cart.length>0", style="margin-top:10px;")
                            table.table.table-sm(style="font-size:12px; line-height: 16px;")
                                tbody
                                    tr(v-for="(item, index) in result.results", :key="item.item_id")
                                        td(style="vertical-align:middle; width:36px;") {{ item.y }}
                                        td(style="text-align: center; vertical-align:middle;")
                                            span {{ item.s }}
                                        td(style="vertical-align:middle; width: 70px;") {{ item.is_set? "セット":"単品"}}<br>{{ item.q }}
                                        td(style="vertical-align:middle; text-align: right; width:51px;") ￥{{ item.price.toLocaleString() }}
                                        td(style="vertical-align:middle; width:44px;")
                                          button.btn.btn-sm.btn-secondary(type="button" style="padding: 4px; width: 35px;" @click="removeCart(item.item_id, index)") 削除
                  div.row(v-show="!fail && result.status==200 && $store.state.listitems.cart.length>0")
                    div.col(style="text-align:right; font-size:16px; padding-right: 20px; margin-bottom: 10px; margin-top: 15px;")
                      span(style="text-decoration: underline;") 合計金額 ￥{{ result.price.toLocaleString() }}
                  div.row(v-show="$store.state.listitems.cart.length>0")
                    div.col-12
                      button.btn.btn-danger.btn-block(type="button" @click="toCart") 詳しく見る / 購入手続きへ
</template>

<script>

export default {
  name: 'NavBar',
  components:{
  },
  data (){
    return {
      result:{ status: 0,  price: 0,  results: [{ item_id: 0, wid: 0, sid: 0, y: 0, s: '', is_set: true, price: 0, eid: NaN, q: '' }] },
      fail:false,
    }
  },
  mounted (){
    $('.navbar-nav>li>a').on('click', function(){
        $('.navbar-collapse').collapse('hide');
    });
    $('#loggedinname').on('click', function(){
        $('.navbar-collapse').collapse('hide');
    });
    $('#loginlabel').on('click', function(){
        $('.navbar-collapse').collapse('hide');
    });
    $('#cartbutton').on('click', function(){
        $('.navbar-collapse').collapse('hide');
    });
  },
  methods:{
    innerWidth (){return window.innerWidth;},
    logout (){
       this.$axios.get("/api/logout")
      .then((response) => {
          this.$store.commit("auth", { loggedin:false, role:"", id:null, email:"", listitems:{ wish:[], cart:[], own:[]} });
          $('.navbar-collapse').collapse('hide');
          this.$router.push("/");
      })
      .catch((error)=>{
        alert("ログアウトできませんでした。");
      });
    },
    showCart (){
      if(window.innerWidth<992)
        this.$router.push("/cart");
      else{
        if(this.$store.state.listitems.cart.length==0){
          this.result = { status: 200,  price: 0,  results: [] }
          return;
        }

        this.fail = false;
        this.result.status = 0;
        let data = this.$store.state.listitems.cart;
         this.$axios.post("/api/cartsummary", data)
        .then((response) => {
          this.result = response.data;
          this.$store.commit("amount", this.result.price);

          if (this.$store.state.listitems.cart.length>0){
              let height = 160 + 41 * this.$store.state.listitems.cart.length;
              let quickcart = document.querySelector(".vue-popover.dropdown-position-bottom[data-popover=cart-quick]");
              if (quickcart){
                let viewHeight = window.innerHeight*.8;
                if (height > viewHeight){
                  quickcart.style.height = "90vh";
                  document.querySelector(".vue-popover.dropdown-position-bottom[data-popover=cart-quick]>div").style.height = "100%";
                }else{
                  quickcart.style.height = null;
                  document.querySelector(".vue-popover.dropdown-position-bottom[data-popover=cart-quick]>div").style.height = null;
                }
              }
          }else{
            let quickcart = document.querySelector(".vue-popover.dropdown-position-bottom[data-popover=cart-quick]");
            if (quickcart){
              quickcart.style.height = null;
              document.querySelector(".vue-popover.dropdown-position-bottom[data-popover=cart-quick]>div").style.height = null;
            }
          }
        })
        .catch((error)=>{
          this.fail = true;
        });
      }
    },
    removeCart: function(item_id, index){
        this.$store.commit("removeCart", item_id);
        this.result.price -= this.result.results[index].price;
        this.$store.commit("amount", this.result.price);
        this.result.results.splice(index,1);
        this.$nextTick(function () {
          let quickcart = document.querySelector(".vue-popover.dropdown-position-bottom[data-popover=cart-quick]>div");
          // helloworld();
          if (quickcart){
            let cartHeight = quickcart.getBoundingClientRect().height;
            let viewHeight = window.innerHeight*.8;
            if (cartHeight < viewHeight)
              quickcart.style.height = null;
          }
        });

    },
    toCart (){
      this.$router.push({ "path":"/cart" });
      document.getElementById("cartbutton").click();
    },
    toMyPage (){
      this.$router.push({ "path":"/mypage" });
      document.getElementById("loggedinname").click();
      $('.navbar-collapse').collapse('hide');
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.nav-link.router-link-exact-active.router-link-active {
    color: rgba(0,0,0,.9);
}

a.nav-link.router-link-active {
    color: rgba(0,0,0,.9);
}

.navbar-brand-label {
  font-size: 1.8rem;
}
.navbar-brand-img {
  width: 50px;
  margin-right:10px;
}

.navbar-height {
  height: 65px;
}

@media(max-width: 400px){
  .navbar-brand-label {
    font-size: 1.3rem;
  }
  .navbar-brand-img {
    width: 35px;
    margin-right:10px;
  }

  .navbar-height {
    height: 44px;
  }
}


h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.vue-popover{
  top: 55px!important;
  padding: 10px;
  line-height: 22px;
  cursor: default;
}

div[data-popover="cart-quick"] {
  left: calc(100vw - 630px)!important;
  /* height: 80vh; */
}

div[data-popover="cart-quick"] .container-fluid {
  overflow-y: auto;
  /* height: 100%; */
}

.vue-popover.dropdown-position-bottom[data-popover="cart-quick"]:before{
  left: calc(96% - 6px)!important;
}

.login-name{
  margin: 0px 10px 0px auto;
  cursor: pointer;
}

.shop-cart{
  font-size:25px;
  margin: 0px;
  cursor: pointer;
}

.ball-clip-rotate>div {
    border: 3px solid lightgray!important;
    border-bottom-color: transparent!important;
    width: 30px!important;
    height: 30px!important;
}

</style>
